export function capitalizeWord(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeWords(string: string) {
  return string
    .split(' ')
    .map((s) => capitalizeWord(s))
    .join(' ');
}

// Simple date formatter that avoids timezone issues
export const formatDateAsString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Helper to get the name of the corresponding author
export const getCorrespondingAuthorName = (
  authors: Array<{
    firstName: string;
    lastName: string;
    corresponding?: boolean;
  }>
): string => {
  const correspondingAuthor = authors.find((author) => author.corresponding);
  if (!correspondingAuthor) return '';

  const firstName = correspondingAuthor.firstName || '';
  const lastName = correspondingAuthor.lastName || '';

  return [firstName, lastName].filter(Boolean).join(' ');
};

export const getFullName = (namedPerson?: {
  firstName?: string;
  lastName?: string;
}): string => {
  if (!namedPerson) return '';
  const { firstName, lastName } = namedPerson;
  if (!firstName && !lastName) return '';
  const firstNameValue = firstName || '';
  const lastNameValue = lastName || '';
  return [firstNameValue, lastNameValue].filter(Boolean).join(' ');
};

export function getLanguageName(
  languageCode: string,
  allLanguages: { [key: string]: { name: string; nativeName: string } }
): string {
  return allLanguages[languageCode]?.name || languageCode;
}

export function getLicenseName(
  licenseCode: string,
  allLicenses: { [key: string]: string }
): string {
  return allLicenses[licenseCode] || licenseCode;
}
